import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import { devConfig, profile } from 'config/config'; // Importing configuration settings from config
import 'webix/photo'; // Importing Webix photo module for image handling
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix for rich text editing

/**
 * Class representing the FilterBetsReportView.
 * @extends JetView
 */
export default class FilterBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Define the left section of the form
        const left = {
            margin: 5, // Margin around the section
            minWidth: 200, // Minimum width of the section
            rows: [
                {
                    view: 'text', // Text input for datepicker
                    name: 'Datepicker', // Name of the input
                    id: 'Datepicker', // Unique identifier for the input
                    css: 'reportrange', // CSS class for styling
                    readonly: true, // Make the input read-only
                    label:
                        "<span class='webix_icon icon-calendar'></span>" + // Icon for the label
                        _('Fecha'), // Localized label text
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
                {
                    view: 'datepicker', // Datepicker input
                    name: 'Date', // Name of the input
                    id: 'Date', // Unique identifier for the input
                    stringResult: true, // Return date as a string
                    minWidth: 200, // Minimum width of the input
                    label:
                        "<span class='webix_icon icon-calendar'></span>" + // Icon for the label
                        _('Fecha'), // Localized label text
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y', // Date format
                    suggest: {
                        type: 'calendar', // Suggestion type
                        body: {
                            maxDate: new Date(), // Maximum selectable date is today
                        },
                    },
                },
                {
                    view: 'richselect', // Dropdown for selecting bet type
                    name: 'TypeBet', // Name of the input
                    label: _('Tipo de Apuesta'), // Localized label text
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar'), // Placeholder text
                    value: 2, // Default selected value
                    options: [
                        // Options for the dropdown
                        { id: '1', value: _('Apuestas Creadas') }, // Option 1
                        { id: '2', value: _('Apuestas Cerradas') }, // Option 2
                        { id: '3', value: _('Apuestas Pagadas') }, // Option 3
                    ],
                },
            ],
        };
        // Define the center-left section of the form
        const center_left = {
            margin: 5, // Margin around the section
            minWidth: 200, // Minimum width of the section
            rows: [
                {
                    view: 'text', // Text input for Ticket Id
                    name: 'Id', // Name of the input
                    label: "<span class='icon-ticket'></span>" + _('Ticket Id'), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Ticket Id'), // Placeholder text
                },
                {
                    view: 'richselect', // Dropdown for selecting state
                    name: 'State', // Name of the input
                    localId: 'bonusStates:combo', // Local identifier for the dropdown
                    label: "<span class='icon-state'></span>" + _('Estado'), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        {
                            id: 'C',
                            value: _('Abierto'), // Open state
                        },
                        {
                            id: 'S',
                            value: _('Ganó'), // Won state
                        },
                        {
                            id: 'N',
                            value: _('Perdió'), // Lost state
                        },
                        {
                            id: 'A',
                            value: _('No Acción'), // No action state
                        },
                        {
                            id: 'R',
                            value: _('Pendiente'), // Pending state
                        },
                        {
                            id: 'W',
                            value: _('En Espera'), // Waiting state
                        },
                        {
                            id: 'J',
                            value: _('Rechazada'), // Rejected state
                        },
                        {
                            id: 'M',
                            value: _('Rechazada por Regla'), // Rejected by rule state
                        },
                        {
                            id: 'T',
                            value: _('Retiro Voluntario'), // Voluntary withdrawal state
                        },
                    ],
                },
            ],
        };
        // Define the center-right section of the form
        const center_right = {
            margin: 5, // Margin around the section
            minWidth: 200, // Minimum width of the section
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting test status
                    name: 'IsTest', // Name of the input
                    localId: 'isTest:combo', // Local identifier for the dropdown
                    label: _('Es Test'), // Localized label text
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options for the dropdown (empty initially)
                },
            ],
        };
        // Define the right section of the form
        const right = {
            margin: 5, // Margin around the section
            minWidth: 200, // Minimum width of the section
            rows: [], // No rows defined initially
        };
        // Define the upper section of the form
        const upper_section = {
            id: 'a1', // Unique identifier for the section
            css: 'father-container', // CSS class for styling
            height: document.body.offsetWidth < 500 ? 130 : 0, // Conditional height based on screen width
            rows: [
                {
                    responsive: 'a1', // Responsive behavior for the section
                    margin: 10, // Margin around the section
                    cols: [
                        left, // Include the left section
                        center_left, // Include the center-left section
                    ],
                },
            ],
        };
        // Define the buttons section
        const buttons = {
            margin: 10, // Margin around the section
            cols: [
                {}, // Empty column for spacing
                {
                    view: 'button', // Button for clearing the form
                    value: _('Limpiar'), // Localized button text
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        // Click event handler
                        this.getRoot().clear(); // Clear the form
                    },
                },
                {
                    view: 'button', // Button for consulting
                    value: _('Consultar'), // Localized button text
                    type: 'form', // Button type
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        // Click event handler
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            // Check date type
                            delete filterdata['Date']; // Remove Date if not applicable
                        } else {
                            if (true) {
                                // Placeholder for additional condition
                                delete filterdata['Datepicker']; // Remove Datepicker if applicable
                            }
                        }
                        this.app.callEvent('betsReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        // Define the accordion section for filters
        const accordion_section = {
            type: 'wide', // Type of accordion
            rows: [
                {
                    multi: true, // Allow multiple sections to be open
                    view: 'accordion', // Accordion view
                    css: 'betShop', // CSS class for styling
                    collapsed: false, // Start expanded
                    type: 'clean', // Clean type for styling
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b5', // Unique identifier for the section
                            body: {
                                padding: 10, // Padding inside the body
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        // Define the second buttons section
        const buttons2 = {
            padding: 10, // Padding around the section
            cols: [
                {
                    view: 'button', // Button for clearing the second form
                    value: _('Limpiar'), // Localized button text
                    click: () => {
                        // Click event handler
                        $$('myForm2').clear(); // Clear the second form
                    },
                },
                {
                    view: 'button', // Button for consulting
                    value: _('Consultar'), // Localized button text
                    type: 'form', // Button type
                    click: () => {
                        // Click event handler
                        const filterdata = $$('myForm2').getValues(); // Get values from the second form
                        if (devConfig.getCountryReport()) {
                            // Check if country report is enabled
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            // Check date type
                            delete filterdata['Date']; // Remove Date if not applicable
                        } else {
                            if (true) {
                                // Placeholder for additional condition
                                delete filterdata['Datepicker']; // Remove Datepicker if applicable
                            }
                        }
                        this.app.callEvent('betsReport:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };
        // Define the third accordion section
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view
            scroll: 'xy', // Enable both horizontal and vertical scrolling
            body: {
                padding: 10, // Padding inside the body
                rows: [upper_section], // Include upper section
            },
        };
        // Define the second accordion section
        const accordion_section2 = {
            type: 'wide', // Type of accordion
            rows: [
                {
                    multi: true, // Allow multiple sections to be open
                    view: 'accordion', // Accordion view
                    css: 'betShop', // CSS class for styling
                    collapsed: false, // Start expanded
                    type: 'clean', // Clean type for styling
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b5', // Unique identifier for the section
                            body: {
                                padding: 10, // Padding inside the body
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        // Define the filter popup window
        const filterPopup = webix.ui({
            view: 'window', // Window view
            move: true, // Allow moving the window
            id: 'filterPopup', // Unique identifier for the window
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the toolbar
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event handler
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position
            body: {
                view: 'form', // Form inside the window
                id: 'myForm2', // Unique identifier for the form
                type: 'clean', // Clean type for styling
                rows: [accordion_section3, buttons2], // Include accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
                },
            },
        });
        // Return the main form configuration
        return {
            type: 'clean', // Clean type for styling
            view: 'form', // Form view
            rows: [
                screen.width > 500 && screen.height > 500 // Conditional rendering based on screen size
                    ? accordion_section2 // Include accordion section if conditions are met
                    : { height: 1, width: 0 }, // Placeholder if conditions are not met
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        webix.ready(function () {
            // Check if the profile typeDate is not equal to 2
            if (profile.typeDate !== 2) {
                // Hide the 'Date' component and show the 'Datepicker' component
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                // If profile.typeDate is 2, execute the following block
                if (true) {
                    // Show the 'Date' component and hide the 'Datepicker' component
                    $$('Date').show();
                    $$('Datepicker').hide();
                }
            }
        });

        // Retrieve the current language setting from the locale service
        const lang = this.app.getService('locale').getLang();

        // Attach an event handler for the 'onAfterRender' event of the 'Datepicker' component
        $$('Datepicker').attachEvent('onAfterRender', function () {
            // Set the date modal configuration based on the current language
            devConfig.setDateModal(lang);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
